import { SystemRole } from '../Enums/system-role.enum';
import { StatusTone } from '../Modules/Shared/Types/status-tone.type';

export const ROLE_TENANT_HEALTH = SystemRole.BACKOFFICE_AGENT;

export const ONBOARDING_STATUS_OPTIONS: readonly string[] = [
  'session_created',
  'company_saved',
  'plan_selected',
  'consent_granted',
  'payment_pending',
  'payment_confirmed',
  'completed',
  'canceled',
];

export const ONBOARDING_STATUS_LABEL: Readonly<Record<string, string>> = {
  session_created: 'backoffice.enums.onboarding_status.session_created',
  company_saved: 'backoffice.enums.onboarding_status.company_saved',
  plan_selected: 'backoffice.enums.onboarding_status.plan_selected',
  consent_granted: 'backoffice.enums.onboarding_status.consent_granted',
  payment_pending: 'backoffice.enums.onboarding_status.payment_pending',
  payment_confirmed: 'backoffice.enums.onboarding_status.payment_confirmed',
  completed: 'backoffice.enums.onboarding_status.completed',
  canceled: 'backoffice.enums.onboarding_status.canceled',
};

export const ONBOARDING_STATUS_TONE: Readonly<Record<string, StatusTone>> = {
  session_created: 'neutral',
  company_saved: 'neutral',
  plan_selected: 'info',
  consent_granted: 'info',
  payment_pending: 'warning',
  payment_confirmed: 'positive',
  completed: 'positive',
  canceled: 'danger',
};

export const TENANT_HEALTH_LABEL: Readonly<Record<string, string>> = {
  healthy: 'backoffice.enums.tenant_health.healthy',
  consent_missing_or_revoked: 'backoffice.enums.tenant_health.consent_missing_or_revoked',
  token_error: 'backoffice.enums.tenant_health.token_error',
  unreachable: 'backoffice.enums.tenant_health.unreachable',
};

export const TENANT_HEALTH_TONE: Readonly<Record<string, StatusTone>> = {
  healthy: 'positive',
  consent_missing_or_revoked: 'danger',
  token_error: 'warning',
  unreachable: 'warning',
};

export const TENANT_HEALTH_RAN_MESSAGE = 'backoffice.onboardings.health.ran';
